<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>Committee</li>
</ul>


<!-- START: tables/datatables -->
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Committee</strong>
    </span>
    <span style="float:right">
      <button class="btn btn-sm btn-primary mb-2" type="button"  data-target="#committeeDialog" (click)="showCommitteePopUp()"
        [appHasPermission]="{'Url': '/committee/edit?goveva=true&email=', 'method':'put', 'menu': 'Committee'}">
        <i class="fa fa-plus"></i>Add Committee</button>
    </span>
  </div>

  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive">
          <table id="committeeTable" datatable [dtOptions]="dtOptions2" [dtTrigger]="dtTrigger" class="row-border hover" class="table table-hover compact cell-border nowrap "
            style="cursor: pointer;">
          </table>

         
          <div class="modal fade show" id="committeeDialog" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
            <div class="modal-dialog" role="document">

              <form [formGroup]="committeeForm" class="well">

                <div class="modal-content">

                  <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabel">
                      <i class="fa fa-plus"></i>Committee Setup</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>

                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-4">
                        <label class="form-control-label" for="l0">Committee Type</label>
                        <span style="color: red;">*</span>
                      </div>
                      <div class="col-md-8">
                        <div class="form-group">
                          <select class="form-control" id="committeeName" [formControl]="committeeForm.controls['committeeName']" style="padding:6px;"
                            aria-placeholder="Select" (change)="committeeChangeEventValidate($event)">
                           
                            <option *ngFor="let committeeNameList of committeeName" [selected]="committeeNameList.IsSelected" [value]="committeeNameList.name">{{committeeNameList.name}}</option>
                    
                          </select>
                          <div *ngIf="committeeIsAvailableInDB " class="form-control-error-custom">
                            Committee is alredy setup.
                          </div>
                        </div>
                      </div>


                      <div class="col-md-4 " *ngIf="otherCommitteeSelected">
                        <label class="form-control-label">Other Committee Name
                          <span style="color: red;">*</span>
                        </label>

                      </div>
                      <div class="col-md-8" *ngIf="otherCommitteeSelected">
                        <div class="form-group">
                          <input type="text" class="form-control" style="padding:6px;" [formControl]="committeeForm.controls['otherCommitteeName']">
                          <div *ngIf="committeeForm.controls['otherCommitteeName'].hasError('required') || (committeeForm.controls['otherCommitteeName'].hasError('whitespace') && committeeForm.controls['otherCommitteeName'].touched)"
                            class="form-control-error-custom">
                            Name for Other Committee Type is required.
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <label class="form-control-label">Committee-Alias
                          <span style="color: red;">*</span>
                        </label>
                      </div>
                      <div class="col-md-8">
                        <div class="form-group">
                          <input id="committeeAlias" type="text" [formControl]="committeeForm.controls['committeeAlias']" class="form-control" style="padding:6px;">
                          <div *ngIf="(committeeForm.controls['committeeAlias'].hasError('required') || committeeForm.controls['committeeAlias'].hasError('whitespace')) && committeeForm.controls['committeeAlias'].touched "
                            class="form-control-error-custom">
                            Committee-Alias is required.
                          </div>
                        </div>
                      </div>


                      <div class="col-md-4">
                        <label class="form-control-label">Committee Short Name
                        
                        </label>
                      </div>
                      <div class="col-md-8">
                        <div class="form-group">
                          <input id="CommitteeShortName" type="text" [formControl]="committeeForm.controls['CommitteeShortName']" class="form-control" style="padding:6px;">
                         
                        </div>
                      </div>


                      <div class="col-md-4">
                        <label class="form-control-label">Frequency - Number of meetings (In Year)
                          <span style="color: red;">*</span>
                        </label>
                      </div>
                      <div class="col-md-8">
                        <div class="form-group">
                          <input type="number" OnlyNumber min="1" [formControl]="committeeForm.controls['meetingFrequency']" class="form-control" style="padding:6px;"
                            [readonly]="readonlyField" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                          <div *ngIf="committeeForm.controls['meetingFrequency'].hasError('required') && committeeForm.controls['meetingFrequency'].touched"
                            class="form-control-error-custom">
                            Frequency - Number of meetings is required.
                          </div>
                          <div *ngIf="committeeForm.controls['meetingFrequency'].errors?.min" class="form-control-error-custom">
                            Minimum required number is 1.
                          </div>
                        </div>
                      </div>




                      <div class="col-md-4">
                        <label class="form-control-label">Gap - between meeting (In Days)
                        </label>
                      </div>
                      <div class="col-md-8">
                        <div class="form-group">
                          <input type="number" OnlyNumber min="1" [formControl]="committeeForm.controls['meetingGap']" class="form-control" style="padding:6px;"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                        
                          <div *ngIf="committeeForm.controls['meetingGap'].errors?.min" class="form-control-error-custom">
                            Minimum required number is 1.
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <label class="form-control-label"> Date of Activation of Committee
                          <span style="color: red;">*</span>
                        </label>
                      </div>
                      <div class="col-md-8" (click)="$event.stopPropagation()" (document:click)="r.close();">
                        <div class="form-group">
                          <div class="input-group">
                            <input class="form-control" [formControl]="committeeForm.controls['activationDate']" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                              name="documentdate" [minDate]="dateOfIncorpOfCompany" [maxDate]="futureDate" ngbDatepicker #r="ngbDatepicker"
                              (focus)="r.toggle();">
                            <button class="input-group-addon" type="button" (click)="r.toggle();">
                              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                            </button>
                          </div>
                          <div *ngIf="committeeForm.controls['activationDate'].hasError('required') && committeeForm.controls['activationDate'].touched"
                            class="form-control-error-custom">
                            Date of Activation of Committee is required
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <label class="form-control-label"> Notice period for meeting (In Days)
                          <span style="color: red;">*</span>
                        </label>
                      </div>

                      <div class="col-md-8">
                        <div class="form-group">
                          <input type="number" OnlyNumber min="1" [formControl]="committeeForm.controls['meetingNoticePeriod']" class="form-control"
                            style="padding:6px;" (focus)="r.close();" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                          <div *ngIf="committeeForm.controls['meetingNoticePeriod'].hasError('required') && committeeForm.controls['meetingNoticePeriod'].touched"
                            class="form-control-error-custom">
                            Notice period for meeting is required.
                          </div>
                        </div>
                      </div>


                      <div class="col-md-4">
                        <label class="form-control-label">Quorum </label>
                        <!-- - No of Directors-->
                      </div>
                      <div class="col-md-8">
                        <div class="form-group">
                          <input type="number" OnlyNumber min="1" [formControl]="committeeForm.controls['quorumDirectors']" class="form-control" style="padding:6px;"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                          <div *ngIf="committeeForm.controls['quorumDirectors'].errors?.min" class="form-control-error-custom">
                            Minimum required number is 1.
                          </div>
                        </div>
                      </div>


                      <div class="col-md-4">
                        <label class="form-control-label"> Charter </label>

                      </div>
                      <div class="col-md-8">
                        <div class="form-group">
                          <input type="file" [formControl]="committeeForm.controls['charterUploadFile']" (change)="charterfileChangeEvent($event)"
                            class="form-control" style="padding:6px;" accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4, .pptx">
                          <span style="color: red" *ngIf="!fileExtension">Please upload valid file format.</span>
                        </div>
                      </div>


                      <div class="col-md-4">
                        <label class="form-control-label"> Policies </label>

                      </div>
                      <div class="col-md-8">
                        <div class="form-group">
                          <input type="file" [formControl]="committeeForm.controls['policies']" (change)="policiesfileChangeEvent($event)" class="form-control"
                            style="padding:6px;" accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .pptx, .mp4">
                          <span style="color: red" *ngIf="!changefileExtension">Please upload valid file format.</span>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <label class="form-control-label">Sitting Fees per Meeting</label>

                      </div>
                      <div class="col-md-8">
                        <div class="form-group">
                          <!-- <input type="text" OnlyNumber CommaSeperatedNumber [formControl]="committeeForm.controls['sittingFees']" class="form-control" style="padding:6px;"> -->
                          <input type="text" OnlyNumber CommaSeperatedNumber [formControl]="committeeForm.controls['sittingFees']" [ngModel]="settingAmount"
                            (input)="limitToAmount()" class="form-control" style="padding:6px;">
                          <div *ngIf="warningALertForSettingAmount" class="form-control-error-custom">
                            Amount must be less than Rs 100,000.
                          </div>
                        </div>
                      </div>


                      <div class="col-md-4">
                        <label class="form-control-label">Statutory Committee</label>
                        <span style="color: red;">*</span>
                      </div>
                      <div class="col-md-8">
                        <div class="form-group">
                          <div class="md-radio md-radio-inline">
                            <input id="statutoryCommitteeYes" type="radio" [formControl]="committeeForm.controls['statutoryCommittee']" name="statutoryCommittee"
                              value="Yes" class="form-check-input">
                            <label for="statutoryCommitteeYes">Yes</label>
                          </div>
                          <div class="md-radio md-radio-inline">
                            <input id="statutoryCommitteeNo" type="radio" [formControl]="committeeForm.controls['statutoryCommittee']" name="statutoryCommittee"
                              value="No" class="form-check-input" [checked]=true>
                            <label for="statutoryCommitteeNo">No</label>
                          </div>
                        </div>
                      </div>
                  

                    </div>
                  </div>

                  <div class="modal-footer">
                     <button id="btnsaveCommittee" type="submit" class="btn btn-sm btn-primary" [disabled]="!committeeForm.valid || committeeIsAvailableInDB || disabledOnclick || !fileExtension || !changefileExtension"
                      (click)="addCommittee()">
                      <i class="fa fa-save"></i>Save
                    </button>

                    <button type="button" class="btn btn-sm" data-dismiss="modal">
                      <i class="fa fa-times"></i>Close</button>
                  </div>

                </div>

              </form>

            </div>
          </div>

          <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div id="alertTitle" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                  Title!
                </div>
                <div class="modal-body" style="padding: 10px 15px;">
                  <div id="alertMessage" style="font-size: 16px;">
                    Message..
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="myModalLabelForDelete">
                    <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-sm-12">
                      Are you sure you want to delete this Committee?
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-sm btn-danger" (click)="deleteCommittee()">
                    <i class="fa fa-check"></i>Yes
                  </button>
                  <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                    <i class="fa fa-times"></i>No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>



    <app-alert></app-alert>
</section>
<!-- END: tables/datatables -->